import empowerdata from '~/assets/thumbnails/empowerdata.png'
import brinkabox from '~/assets/thumbnails/brinkabox.png'
import ugrowth from '~/assets/thumbnails/ugrowth.png'
import ugrowthAdmin from '~/assets/thumbnails/ugrowth-admin.png'
import hbacai from '~/assets/thumbnails/hbacaistore.png'

export const projects = [
  {
    name: 'HB Açaí',
    image: hbacai,
    tags: ['Next.js', 'Stitches', 'Typescript'],
    description: 'Restaurant website.',
    link: 'https://hbacai.vercel.app/'
  },
  {
    name: 'Ugrowth',
    image: ugrowth,
    tags: ['React', 'Styled components', 'Typescript'],
    description: 'Online course platform on demand.',
    link: 'https://deploy-preview-14--confident-dijkstra-7f4c7d.netlify.app/'
  },
  {
    name: 'Empowerdata',
    image: empowerdata,
    tags: ['React', 'Emotion', 'framer-motion'],
    description: 'Website to Business Intelligence & Analytics courses.',
    link: 'https://www.empowerdata.com.br/'
  },
  {
    name: 'Ugrowth admin',
    image: ugrowthAdmin,
    tags: ['React', 'Styled components'],
    description: 'Front-end admin for online course platform.',
    link: 'https://deploy-preview-18--practical-curran-19f835.netlify.app/admin'
  },
  {
    name: 'Brinkabox',
    image: brinkabox,
    tags: ['HTML5', 'CSS3', 'Javascript'],
    description: 'Signature toy box website.',
    link: 'https://brinkabox-preview.netlify.app/'
  }
]
